export default `#include <common>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
uniform float linewidth;uniform vec2 resolution;attribute vec3 instanceStart;attribute vec3 instanceEnd;varying vec3 vInstanceStart;varying vec3 vInstanceEnd;
#ifdef USE_COLOR
#ifdef USE_LINE_COLOR_ALPHA
varying vec4 vLineColor;attribute vec4 instanceColorStart;attribute vec4 instanceColorEnd;
#else
varying vec3 vLineColor;attribute vec3 instanceColorStart;attribute vec3 instanceColorEnd;
#endif
#endif
#ifdef WORLD_UNITS
varying vec4 worldPos;varying vec3 worldStart;varying vec3 worldEnd;
#ifdef USE_DASH
varying vec2 vUv;
#endif
#else
varying vec2 vUv;
#endif
#ifdef USE_DASH
uniform float dashScale;attribute float instanceDistanceStart;attribute float instanceDistanceEnd;varying float vLineDistance;
#endif
void trimSegment(const in vec4 start,inout vec4 end){float a=projectionMatrix[2][2];float b=projectionMatrix[3][2];float nearEstimate=-0.5*b/a;float alpha=(nearEstimate-start.z)/(end.z - start.z);end.xyz=mix(start.xyz,end.xyz,alpha);}void main(){vInstanceStart=instanceStart;vInstanceEnd=instanceEnd;
#ifdef USE_COLOR
vLineColor=(position.y<0.5)? instanceColorStart : instanceColorEnd;
#endif
#ifdef USE_DASH
vLineDistance=(position.y<0.5)? dashScale*instanceDistanceStart : dashScale*instanceDistanceEnd;vUv=uv;
#endif
float aspect=resolution.x/resolution.y;vec4 start=modelViewMatrix*vec4(instanceStart,1.0);vec4 end=modelViewMatrix*vec4(instanceEnd,1.0);
#ifdef WORLD_UNITS
worldStart=start.xyz;worldEnd=end.xyz;
#else
vUv=uv;
#endif
bool perspective=(projectionMatrix[2][3]==-1.0);if(perspective){if(start.z<0.0&&end.z>=0.0){trimSegment(start,end);}else if(end.z<0.0&&start.z>=0.0){trimSegment(end,start);}}vec4 clipStart=projectionMatrix*start;vec4 clipEnd=projectionMatrix*end;vec3 ndcStart=clipStart.xyz/clipStart.w;vec3 ndcEnd=clipEnd.xyz/clipEnd.w;vec2 dir=ndcEnd.xy-ndcStart.xy;dir.x*=aspect;dir=normalize(dir);
#ifdef WORLD_UNITS
vec3 worldDir=normalize(end.xyz-start.xyz);vec3 offset;if(position.y<0.5){offset=normalize(cross(start.xyz,worldDir));}else{offset=normalize(cross(end.xyz,worldDir));}if(position.x<0.0)offset*=-1.0;float forwardOffset=dot(worldDir,vec3(0.0,0.0,1.0));
#ifndef USE_DASH
start.xyz+=-worldDir*linewidth*0.5;end.xyz+=worldDir*linewidth*0.5;offset.xy-=dir*forwardOffset;offset.z+=0.5;
#endif
if(position.y>1.0||position.y<0.0){offset.xy+=dir*2.0*forwardOffset;}offset*=linewidth*0.5;worldPos=(position.y<0.5)? start : end;worldPos.xyz+=offset;vec4 clip=projectionMatrix*worldPos;vec3 clipPose=(position.y<0.5)? ndcStart : ndcEnd;clip.z=clipPose.z*clip.w;
#else
vec2 offset=vec2(dir.y,-dir.x);dir.x/=aspect;offset.x/=aspect;if(position.x<0.0)offset*=-1.0;if(position.y<0.0){offset+=-dir;}else if(position.y>1.0){offset+=dir;}offset*=linewidth;offset/=resolution.y;vec4 clip=(position.y<0.5)? clipStart : clipEnd;offset*=clip.w;clip.xy+=offset;
#endif
gl_Position=clip;vec4 mvPosition=(position.y<0.5)? start : end;
#include <logdepthbuf_vertex>
#include <clipping_planes_vertex>
#include <fog_vertex>
}`